<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card class="elevation-6 mx-auto" max-width="500">
            <v-img
              class="white--text align-end"
              height="320px"
              src="../assets/smartphone.png"
            ></v-img>
            <v-card-title primary-title>
              <span class="text-h5">毕业账单后台 - 404</span>
            </v-card-title>
            <v-card-text>
              <p class="mb-0 text-subtitle-1">你似乎来到了没有数据存在的荒原…</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange" text to="/main">
                返回首页
              </v-btn>
              <v-btn color="orange" text @click="goBack">
                返回上页
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'Error404',
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  }
}
</script>
